/**
 * @flow
 */

/* eslint-disable */

'use strict';

/*::
import type { ConcreteRequest } from 'relay-runtime';
export type DeleteGoogleDriveProjectFileLinkInput = {|
  id?: ?string,
  projectId?: ?string,
  csrfToken?: ?string,
  socketClientId?: ?string,
  clientMutationId?: ?string,
|};
export type deleteGoogleDriveProjectFileLinkMutationVariables = {|
  input: DeleteGoogleDriveProjectFileLinkInput
|};
export type deleteGoogleDriveProjectFileLinkMutationResponse = {|
  +deleteGoogleDriveProjectFileLink: ?{|
    +deletedGoogleDriveFileId: ?string
  |}
|};
export type deleteGoogleDriveProjectFileLinkMutation = {|
  variables: deleteGoogleDriveProjectFileLinkMutationVariables,
  response: deleteGoogleDriveProjectFileLinkMutationResponse,
|};
*/


/*
mutation deleteGoogleDriveProjectFileLinkMutation(
  $input: DeleteGoogleDriveProjectFileLinkInput!
) {
  deleteGoogleDriveProjectFileLink(input: $input) {
    deletedGoogleDriveFileId
  }
}
*/

const node/*: ConcreteRequest*/ = (function(){
var v0 = [
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "input",
    "type": "DeleteGoogleDriveProjectFileLinkInput!"
  }
],
v1 = [
  {
    "alias": null,
    "args": [
      {
        "kind": "Variable",
        "name": "input",
        "variableName": "input"
      }
    ],
    "concreteType": "DeleteGoogleDriveProjectFileLinkPayload",
    "kind": "LinkedField",
    "name": "deleteGoogleDriveProjectFileLink",
    "plural": false,
    "selections": [
      {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "deletedGoogleDriveFileId",
        "storageKey": null
      }
    ],
    "storageKey": null
  }
];
return {
  "fragment": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Fragment",
    "metadata": null,
    "name": "deleteGoogleDriveProjectFileLinkMutation",
    "selections": (v1/*: any*/),
    "type": "Mutation"
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Operation",
    "name": "deleteGoogleDriveProjectFileLinkMutation",
    "selections": (v1/*: any*/)
  },
  "params": {
    "id": null,
    "metadata": {},
    "name": "deleteGoogleDriveProjectFileLinkMutation",
    "operationKind": "mutation",
    "text": "mutation deleteGoogleDriveProjectFileLinkMutation(\n  $input: DeleteGoogleDriveProjectFileLinkInput!\n) {\n  deleteGoogleDriveProjectFileLink(input: $input) {\n    deletedGoogleDriveFileId\n  }\n}\n"
  }
};
})();
// prettier-ignore
(node/*: any*/).hash = 'e50e749aad6b9358b5d072cb415a82ac';

module.exports = node;
